// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#afis-app #com_mod_valuation tr td[data-v-5ed2c434]:not(:first-child) {
  color: #333333;
}
#afis-app #com_mod_valuation thead tr:nth-child(2) th[data-v-5ed2c434] {
  padding: 0px 5px 5px 10px;
}
#afis-app #com_mod_valuation td[data-v-5ed2c434] {
  padding: 5px 5px 5px 0px;
  margin: 1px 0px 1px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/Valuation.vue","webpack://./Valuation.vue"],"names":[],"mappings":"AACA;EAGG,cAAA;ACFH;ADDA;EAQK,yBAAA;ACJL;ADJA;EAaG,wBAAA;EACA,uBAAA;ACNH","sourcesContent":["\n#afis-app {\n\t#com_mod_valuation {\n\t\ttr td:not(:first-child) {\n\t\t\tcolor: #333333;\n\t\t}\n\t\tthead {\n\t\t\ttr:nth-child(2) {\n\t\t\t\tth {\n\t\t\t\t\tpadding: 0px 5px 5px 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttd {\n\t\t\tpadding: 5px 5px 5px 0px;\n\t\t\tmargin: 1px 0px 1px 0px;\n\t\t}\n\t}\n}\n\n\n","#afis-app #com_mod_valuation tr td:not(:first-child) {\n  color: #333333;\n}\n#afis-app #com_mod_valuation thead tr:nth-child(2) th {\n  padding: 0px 5px 5px 10px;\n}\n#afis-app #com_mod_valuation td {\n  padding: 5px 5px 5px 0px;\n  margin: 1px 0px 1px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
